import { createContext } from 'react';

import { CourseEnrolModalInfo, CourseRegisterInterestModalInfo, ModalInfo } from 'src/types/ModalInfo';

type ModalState = {
	modalInfo: ModalInfo | undefined;
	hideAllModals: () => void;
	updateModalInfo: (modalInfo: ModalInfo | undefined) => void;
	updateDisplayCourseEnrolModal: (display: boolean) => void;
	updateCourseEnrolModal: (courseEnrolModalInfo: CourseEnrolModalInfo) => void;
	updateDisplayCourseRegisterInterestModal: (display: boolean) => void;
	updateCourseRegisterInterestModal: (courseRegisterInterestModalInfo: CourseRegisterInterestModalInfo) => void;
	updateDisplayLoginFormModal: (display: boolean) => void;
};

export const defaultModalState: ModalState = {
	modalInfo: undefined,
	hideAllModals: () => {
		console.log('Default hideAllModals');
	},
	updateModalInfo: (modalInfo: ModalInfo | undefined) => {
		console.log(`Default updateModalInfo: ${modalInfo}`);
	},
	updateDisplayCourseEnrolModal: (display: boolean) => {
		console.log(`Default updateDisplayCourseEnrolModal: ${display}`);
	},
	updateCourseEnrolModal: (courseEnrolModalInfo: CourseEnrolModalInfo) => {
		console.log(`Default updateCourseEnrolModal: ${courseEnrolModalInfo}`);
	},
	updateDisplayCourseRegisterInterestModal: (display: boolean) => {
		console.log(`Default updateDisplayCourseRegisterInterestModal: ${display}`);
	},
	updateCourseRegisterInterestModal: (courseRegisterInterestModal: CourseRegisterInterestModalInfo) => {
		console.log(`Default updateCourseRegisterInterestModal: ${courseRegisterInterestModal}`);
	},
	updateDisplayLoginFormModal: (display: boolean) => {
		console.log(`Default updateDisplayLoginFormModal: ${display}`);
	},
};

export const ModalContext = createContext<ModalState>(defaultModalState);
